import { ZI_COOKIE } from 'config.js';
import localStorageTemplates from 'common/local-storage-templates';

export const readCookie = cname => {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

export const readToken = () => {
  let token = '';
  if (window.appDetails.isZIDashboard) {
    token = readCookie(ZI_COOKIE);
  } else {
    token = localStorage.getItem(localStorageTemplates.insentPublisherLoginToken);
  }
  return token;
};
